/**
 * Events Configuration
 *
 * Centralized configuration for event notifications and banners.
 * In the future, this will be replaced with database-driven events.
 *
 * TODO: Integrate with backend API for dynamic event management
 */

import { Event, EventPriority, EventType } from "@/types/events.types";

/**
 * Active Events Configuration
 * Add new events here until database integration is complete
 */
export const ACTIVE_EVENTS: Event[] = [
  {
    id: "rajiv-dixit-memorial-2025",
    title: "Rajiv Dixit Ji Memorial - Vichar Goshti",
    description:
      "30 नवम्बर - द्वितीय स्वदेशी विचारक स्व. राजीव दीक्षित जी जन्म व पुण्यतिथि पर आयोजित विचार गोष्ठी। स्वस्थ समृद्ध परिवार नारी सुरक्षा सेवा व्यवस्थाय (भारतीय बचत व्यवस्था) के सभी सदस्यों के साथ हम इस महान स्वदेशी विचारक को श्रद्धांजलि अर्पित करते हैं।",
    type: EventType.MEMORIAL,
    priority: EventPriority.HIGH,
    startDate: new Date("2025-10-23"), // Start showing from today
    endDate: new Date("2025-11-30T23:59:59"), // Event day
    bannerImageUrl: "/images/events/rajiv-dixit-memorial-2024.jpg",
    detailsImageUrl: "/images/events/rajiv-dixit-memorial-2024.jpg",
    showBanner: true,
    showModal: true,
    dismissible: true,
    actionUrl: undefined,
    actionLabel: undefined,
    createdAt: new Date("2025-10-23"),
    updatedAt: new Date("2025-10-23"),
  },
];

/**
 * Check if an event is currently active
 */
export const isEventActive = (event: Event): boolean => {
  const now = new Date();
  return now >= event.startDate && now <= event.endDate;
};

/**
 * Get all currently active events
 */
export const getActiveEvents = (): Event[] => {
  return ACTIVE_EVENTS.filter(isEventActive);
};

/**
 * Get active events that should show banner
 */
export const getActiveBannerEvents = (): Event[] => {
  return getActiveEvents().filter((event) => event.showBanner);
};

/**
 * Get active events that should show modal
 */
export const getActiveModalEvents = (): Event[] => {
  return getActiveEvents().filter((event) => event.showModal);
};

/**
 * Calculate days remaining until event
 */
export const getDaysUntilEvent = (eventDate: Date): number => {
  const now = new Date();
  const diffTime = eventDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays);
};

/**
 * Calculate hours remaining until event
 */
export const getHoursUntilEvent = (eventDate: Date): number => {
  const now = new Date();
  const diffTime = eventDate.getTime() - now.getTime();
  const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
  return Math.max(0, diffHours);
};

/**
 * Format countdown text
 */
export const getCountdownText = (eventDate: Date): string => {
  const days = getDaysUntilEvent(eventDate);

  if (days === 0) {
    const hours = getHoursUntilEvent(eventDate);
    if (hours === 0) {
      return "आज का दिन है!";
    }
    return `${hours} घंटे बाकी`;
  }

  return `${days} दिन बाकी`;
};
